import React, { useState } from "react";
import { TextInput, View } from "react-native";
import CheckIcon from "@assets/svg/CheckGreen";
import Text from "@components/CustomText";
import t from "@constants/localization";
import Photo from "./Photo";
import Comment from "./Comment";
import { saveJsonData, removeJson } from "../../../utils/commonFunctions";
import { kycStyles as s, kycColors } from "./styles";

const PATH = "screens/KYCSetup/AadharSection";

const AADHAR_NUMBER_REGEX = /[0-9]{12}/;

const AadharSection = (props) => {
  const {
    aadharNumber,
    setAadharNumber,
    aadharFront,
    aadharBack,
    uploadAadharFront,
    uploadAadharBack,
    removeAadharFront,
    removeAadharBack,
    disableAadharSection,
    verified,
    rejectionComment = null,
    testAadharID = "",
    draftKey = null,
    imageHeaders = null,
  } = props;
  const [unmatched, setUnmatched] = useState(false);
  const [focused, setFocused] = useState(false);

  const { source: frontSource = "", localUri: frontPreview = "" } = aadharFront;
  const { source: backSource = "", localUri: backPreview = "" } = aadharBack;

  const _onBlur = () => {
    setFocused(false);
    if (aadharNumber && aadharNumber.length) {
      // Persist a valid number as a user-scoped draft (draftKey is null when
      // there's no scope id → skip). Invalid → flag and drop any stale draft.
      if (AADHAR_NUMBER_REGEX.test(aadharNumber.replace(/\s/g, ""))) {
        if (draftKey) saveJsonData(draftKey, aadharNumber);
      } else {
        setUnmatched(true);
        if (draftKey) removeJson(draftKey);
      }
    }
  };

  const _onChangeText = (text) => {
    setUnmatched(false);
    setAadharNumber(text);
  };

  return (
    <View style={s.section}>
      <Comment kycComment={rejectionComment} />
      {verified ? (
        <View style={s.verifiedRow}>
          <CheckIcon fill="rgba(0,171,89,1)" size={18} />
          <Text style={s.verifiedText}>{t(`${PATH}/verified`)}</Text>
        </View>
      ) : (
        <Text style={s.sectionLabel}>
          {t(`${PATH}/aadharNumber`)}
          {!disableAadharSection && <Text style={s.requiredStar}>*</Text>}
        </Text>
      )}
      <View
        style={[
          s.inputBox,
          focused && s.inputBoxFocused,
          unmatched && s.inputBoxError,
          disableAadharSection && s.inputBoxDisabled,
        ]}
      >
        <TextInput
          testID={testAadharID}
          editable={!disableAadharSection}
          style={s.inputText}
          placeholder="1234 5678 9012"
          placeholderTextColor={kycColors.placeholder}
          value={aadharNumber}
          maxLength={12}
          onFocus={() => setFocused(true)}
          onBlur={_onBlur}
          onChangeText={_onChangeText}
          keyboardType="numeric"
        />
      </View>
      {unmatched ? (
        <Text style={s.errorText}>{t(`${PATH}/checkYourAadhar`)}</Text>
      ) : null}
      <View style={[s.uploadRow, { marginTop: 12 }]}>
        <Photo
          source={frontSource}
          previewUri={frontPreview}
          imageHeaders={imageHeaders}
          ctaText={t(`${PATH}/frontPhoto`)}
          onUpload={uploadAadharFront}
          onDelete={removeAadharFront}
          disabled={disableAadharSection}
          style={{ flex: 1 }}
        />
        <Photo
          source={backSource}
          previewUri={backPreview}
          imageHeaders={imageHeaders}
          ctaText={t(`${PATH}/backPhoto`)}
          onUpload={uploadAadharBack}
          onDelete={removeAadharBack}
          disabled={disableAadharSection}
          style={{ flex: 1 }}
        />
      </View>
    </View>
  );
};

export default AadharSection;
